import { createSelector } from '@reduxjs/toolkit';
import { selectWheelchairAccessible } from 'shared/selectors/jsonQuery';

export const selectWheelchairAccessibleFilter = createSelector(selectWheelchairAccessible, value => ({
  label: 'Доступно для людей на колясках',
  value: Boolean(value),
}));
